<template>
  <ChecklistsOverview />
</template>

<script lang="ts">
import Vue from "vue";
import ChecklistsOverview from "@/components/checklists/container/ChecklistsOverview.vue";

export default Vue.extend({
  components: {
    ChecklistsOverview,
  },
});
</script>
